class StickyCart extends HTMLElement {
  constructor() {
    super();
    this.initialLoad = true;
    this.stickyCartTrigger = document.querySelector('sticky-cart-trigger');
    this.body = document.querySelector('body');
    this.listReference = this.querySelector(`[js-sticky-cart="list-ref"]`);

    if (this.listReference) {
      this.listReference.addEventListener('click', (e) => {
        this.renderOptions();
      })
    }

    if(!this.stickyCartTrigger) return;

    this.addEventListener('transitionend', () => {
      if(!this.classList.contains('is-visible')) this.classList.remove('is-sticky')
    })

    window.addEventListener('resize', () => {
      this.handleTopPosition();
    });

    // list to dispatch closeBar event
    document.addEventListener('closeBar', () => {
      this.forceCloseBar();
    })

    document.addEventListener('openBar', () => {
      this.forceOpenBar();
    })

    this.initObserver();
  }

  static get observedAttributes() {
    return ['data-open'];
  }

  initObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    }

    const observer = new IntersectionObserver(this.handleStickyCart.bind(this), options)
    observer.observe(this.stickyCartTrigger)
  }

  handleStickyCart() {
    const triggerCoordsY = this.stickyCartTrigger.getBoundingClientRect().top

    if(triggerCoordsY < 0) {
      this.classList.add('is-sticky')
      this.classList.add('is-visible')
      this.body.style.paddingBottom = this.getBoundingClientRect().height + 'px';
      this.handleTopPosition();
    } else {
      this.classList.remove('is-visible')
      this.body.style.paddingBottom = '0px';
    }
  }

  forceCloseBar() {
    this.classList.add('is-forced-close')
    this.body.style.paddingBottom = '0px';
  }

  forceOpenBar() {
    this.classList.remove('is-forced-close')
    this.body.style.paddingBottom = this.getBoundingClientRect().height + 'px';
  }

  // Add top: 'x' based on the height of the header
  handleTopPosition() {
    const headerHeight = document.querySelector('header').offsetHeight;
    this.style.top = `${headerHeight}px`;
  }

  renderOptions() {
    this.toggleAttribute('data-open');
    this.classList.toggle('is-open');
  }
}

customElements.define('sticky-cart', StickyCart);

class StickyCartTrigger extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('sticky-cart-trigger', StickyCartTrigger);
